import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation DeleteAgentChatWorkspace($tenantId: ID!, $zoneId: ID!, $id: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        deleteAgentChatWorkspace(id: $id)
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.DeleteAgentChatWorkspaceMutation,
  void,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'deleteAgentChatWorkspace',
      graphql.transformers.OUT.always(undefined),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.DeleteAgentChatWorkspaceMutation,
  void,
  graphql.schema.DeleteAgentChatWorkspaceMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
